// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2020." + {"282":"ce30b546526ef0ebcea8","678":"c30300fb3882750f3079","814":"4413e41edd20237e25b1"}[chunkId] + ".js";
};